// Self-contained translations for the DCA Simulator view.
// Full ES / EN / SK coverage. Pattern mirrors /src/i18n/cycles.js.
export const DCA_T = {
  es: {
    title: "Simulador DCA Histórico",
    subtitle:
      "¿Qué habría pasado si hubieras comprado $X cada semana en cripto?",
    back_to_liqmap: "← Volver al Liquidity Map",
    open_cycles: "📈 Ciclos",
    open_cycles_title: "Ir al Mapa de Ciclos Históricos",
    loading: "Cargando datos históricos…",
    simulating: "Simulando…",
    err_load: "No pudimos cargar los datos. Intenta de nuevo.",
    err_simulate: "No pudimos calcular la simulación.",
    retry: "Reintentar",
    // Form
    form_title: "Parámetros de la simulación",
    form_coin: "Activo",
    form_start: "Fecha de inicio",
    form_start_help: "Primer cierre semanal disponible: {date}",
    form_amount: "Monto semanal (USD)",
    form_fee: "Comisión por compra (%)",
    form_fee_help: "Estimado. Tu exchange real puede aplicar tarifas distintas.",
    form_submit: "Calcular DCA",
    form_reset: "Reiniciar",
    // BNB tooltip
    bnb_disabled_label: "BNB",
    bnb_disabled_tooltip:
      "Histórico insuficiente en Kraken (<2 años, desde 2025-04-17) — disponible próximamente.",
    // Summary
    summary_title: "Resultado de la simulación",
    summary_invested: "Total invertido",
    summary_invested_help: "Monto bruto. Incluye comisiones pagadas.",
    summary_current_value: "Valor actual",
    summary_current_value_help: "Coin acumulada × precio actual.",
    summary_pnl: "Ganancia / Pérdida",
    summary_pnl_pct: "{pct}%",
    summary_coin_total: "{coin} acumulado",
    summary_avg_cost: "Coste medio por {coin}",
    summary_fees_total: "Comisiones pagadas",
    summary_weeks: "{n} semanas",
    summary_first_buy: "Primera compra: {date}",
    summary_last_buy: "Última compra: {date}",
    summary_current_price: "Precio actual: {price}",
    // Chart
    chart_title: "Evolución semana a semana",
    chart_subtitle:
      "Valor del portfolio vs total invertido (acumulado). Cierres semanales.",
    chart_axis_y_usd: "USD",
    chart_legend_value: "Valor del portfolio",
    chart_legend_invested: "Total invertido",
    // Table
    table_title: "Detalle semana a semana",
    table_collapsed: "Ver detalle ({n} semanas)",
    table_expanded: "Ocultar detalle",
    table_col_date: "Fecha",
    table_col_price: "Precio",
    table_col_invested: "Invertido",
    table_col_fee: "Comisión",
    table_col_coin_bought: "Comprado",
    table_col_coin_acc: "Acumulado",
    table_col_value: "Valor",
    // Caveats — same pattern as Cycles "Lo que este gráfico NO te dice"
    caveats_panel_title: "Lo que esta simulación NO te dice",
    caveats_panel_intro:
      "Cinco límites honestos antes de interpretar el resultado:",
    caveats_retrospective:
      "Esto muestra qué HABRÍA pasado con estos parámetros exactos. NO es una predicción de qué pasará si DCAeas desde hoy.",
    caveats_cherry_picking:
      "El resultado cambia drásticamente según la fecha de inicio. Empezar 3 meses antes/después puede cambiar el PnL >50%. Prueba varias fechas.",
    caveats_no_slippage:
      "Asume ejecución perfecta al cierre semanal. En la realidad hubo spread, slippage y a veces falta de disponibilidad en exchanges durante eventos extremos (Mar 2020, FTX, etc.).",
    caveats_fees_estimated:
      "El % de comisión es uniforme — tu exchange real cobra distinto según volumen, par y tipo de orden (maker/taker, VIP, descuentos por staking).",
    caveats_no_taxes:
      "No incluye impuestos sobre plusvalías ni renta. Tu jurisdicción puede aplicar 19-35%+ sobre la ganancia al vender.",
    // Misc
    source_label: "Fuente: Kraken OHLC semanal",
    no_data_yet: "Completa el formulario para ver el resultado.",
    // Entry button (used by LiqScoreWidget + CyclesMapView)
    entry_button_label: "💰 DCA",
    entry_button_title:
      "Abrir simulador DCA histórico — qué habría pasado si invertías cada semana",
  },
  en: {
    title: "Historical DCA Simulator",
    subtitle:
      "What would have happened if you had bought $X of crypto every week?",
    back_to_liqmap: "← Back to Liquidity Map",
    open_cycles: "📈 Cycles",
    open_cycles_title: "Go to the Historical Cycles Map",
    loading: "Loading historical data…",
    simulating: "Simulating…",
    err_load: "Could not load data. Try again.",
    err_simulate: "Could not run the simulation.",
    retry: "Retry",
    form_title: "Simulation parameters",
    form_coin: "Asset",
    form_start: "Start date",
    form_start_help: "First weekly close available: {date}",
    form_amount: "Weekly amount (USD)",
    form_fee: "Per-buy fee (%)",
    form_fee_help: "Estimated. Your real exchange may charge different fees.",
    form_submit: "Run DCA",
    form_reset: "Reset",
    bnb_disabled_label: "BNB",
    bnb_disabled_tooltip:
      "Insufficient Kraken history (<2 years, since 2025-04-17) — coming soon.",
    summary_title: "Simulation result",
    summary_invested: "Total invested",
    summary_invested_help: "Gross amount. Includes fees paid.",
    summary_current_value: "Current value",
    summary_current_value_help: "Accumulated coin × current price.",
    summary_pnl: "Gain / Loss",
    summary_pnl_pct: "{pct}%",
    summary_coin_total: "{coin} accumulated",
    summary_avg_cost: "Average cost per {coin}",
    summary_fees_total: "Fees paid",
    summary_weeks: "{n} weeks",
    summary_first_buy: "First buy: {date}",
    summary_last_buy: "Last buy: {date}",
    summary_current_price: "Current price: {price}",
    chart_title: "Week-by-week evolution",
    chart_subtitle:
      "Portfolio value vs total invested (cumulative). Weekly closes.",
    chart_axis_y_usd: "USD",
    chart_legend_value: "Portfolio value",
    chart_legend_invested: "Total invested",
    table_title: "Week-by-week detail",
    table_collapsed: "Show detail ({n} weeks)",
    table_expanded: "Hide detail",
    table_col_date: "Date",
    table_col_price: "Price",
    table_col_invested: "Invested",
    table_col_fee: "Fee",
    table_col_coin_bought: "Bought",
    table_col_coin_acc: "Accumulated",
    table_col_value: "Value",
    caveats_panel_title: "What this simulation does NOT tell you",
    caveats_panel_intro:
      "Five honest limits before interpreting the result:",
    caveats_retrospective:
      "This shows what WOULD have happened with these exact parameters. It is NOT a prediction of what will happen if you DCA from today.",
    caveats_cherry_picking:
      "Results change drastically with the start date. Starting 3 months earlier/later can change PnL by >50%. Try multiple dates.",
    caveats_no_slippage:
      "Assumes perfect execution at weekly close. In reality there was spread, slippage and at times no exchange availability during extreme events (Mar 2020, FTX, etc.).",
    caveats_fees_estimated:
      "The fee % is uniform — your real exchange charges differently by volume, pair and order type (maker/taker, VIP tiers, staking discounts).",
    caveats_no_taxes:
      "Does not include capital-gains or income tax. Your jurisdiction may apply 19-35%+ on gains when you sell.",
    source_label: "Source: Kraken weekly OHLC",
    no_data_yet: "Fill in the form to see the result.",
    entry_button_label: "💰 DCA",
    entry_button_title:
      "Open historical DCA simulator — what would have happened if you invested weekly",
  },
  sk: {
    title: "Historický DCA Simulátor",
    subtitle:
      "Čo by sa stalo, keby si kupoval krypto za $X každý týždeň?",
    back_to_liqmap: "← Späť na Liquidity Map",
    open_cycles: "📈 Cykly",
    open_cycles_title: "Otvoriť Mapu historických cyklov",
    loading: "Načítavam historické dáta…",
    simulating: "Simulujem…",
    err_load: "Dáta sa nepodarilo načítať. Skús znova.",
    err_simulate: "Simuláciu sa nepodarilo spustiť.",
    retry: "Skúsiť znova",
    form_title: "Parametre simulácie",
    form_coin: "Aktívum",
    form_start: "Dátum začiatku",
    form_start_help: "Prvý dostupný týždenný close: {date}",
    form_amount: "Týždenná suma (USD)",
    form_fee: "Poplatok za nákup (%)",
    form_fee_help: "Odhad. Tvoja burza môže účtovať iné poplatky.",
    form_submit: "Spustiť DCA",
    form_reset: "Reset",
    bnb_disabled_label: "BNB",
    bnb_disabled_tooltip:
      "Nedostatočná Kraken história (<2 roky, od 2025-04-17) — pripravujeme.",
    summary_title: "Výsledok simulácie",
    summary_invested: "Celkom investované",
    summary_invested_help: "Brutto. Vrátane zaplatených poplatkov.",
    summary_current_value: "Súčasná hodnota",
    summary_current_value_help: "Nazbieraná coin × súčasná cena.",
    summary_pnl: "Zisk / Strata",
    summary_pnl_pct: "{pct}%",
    summary_coin_total: "Nazbierané {coin}",
    summary_avg_cost: "Priemerná cena za {coin}",
    summary_fees_total: "Zaplatené poplatky",
    summary_weeks: "{n} týždňov",
    summary_first_buy: "Prvý nákup: {date}",
    summary_last_buy: "Posledný nákup: {date}",
    summary_current_price: "Aktuálna cena: {price}",
    chart_title: "Evolúcia týždeň po týždni",
    chart_subtitle:
      "Hodnota portfólia vs celkom investované (kumulatívne). Týždenné close.",
    chart_axis_y_usd: "USD",
    chart_legend_value: "Hodnota portfólia",
    chart_legend_invested: "Celkom investované",
    table_title: "Detail po týždňoch",
    table_collapsed: "Zobraziť detail ({n} týždňov)",
    table_expanded: "Skryť detail",
    table_col_date: "Dátum",
    table_col_price: "Cena",
    table_col_invested: "Investované",
    table_col_fee: "Poplatok",
    table_col_coin_bought: "Kúpené",
    table_col_coin_acc: "Nazbierané",
    table_col_value: "Hodnota",
    caveats_panel_title: "Čo táto simulácia NEHOVORÍ",
    caveats_panel_intro:
      "Päť čestných limitov pred interpretáciou výsledku:",
    caveats_retrospective:
      "Toto ukazuje, čo by sa BOLO stalo s presne týmito parametrami. NIE je to predikcia toho, čo sa stane, ak DCA-ješ od dnes.",
    caveats_cherry_picking:
      "Výsledok sa drasticky mení podľa dátumu začiatku. Začať o 3 mesiace skôr/neskôr môže zmeniť PnL o >50%. Skús viac dátumov.",
    caveats_no_slippage:
      "Predpokladá perfektnú exekúciu pri týždennom close. V realite bol spread, slippage a niekedy aj nedostupnosť búrz počas extrémnych udalostí (Mar 2020, FTX, atď.).",
    caveats_fees_estimated:
      "Poplatok % je uniformný — tvoja burza účtuje rôzne podľa objemu, páru a typu objednávky (maker/taker, VIP, staking zľavy).",
    caveats_no_taxes:
      "Nezahŕňa daň zo zisku ani z príjmu. Tvoja jurisdikcia môže pri predaji uplatniť 19-35%+.",
    source_label: "Zdroj: Kraken týždenné OHLC",
    no_data_yet: "Vyplň formulár, aby si videl výsledok.",
    entry_button_label: "💰 DCA",
    entry_button_title:
      "Otvoriť historický DCA simulátor — čo by sa stalo, keby si investoval týždenne",
  },
  "zh-CN": {
    title: "历史DCA模拟器",
    subtitle: "如果您每周购买$X的加密货币会怎样？",
    back_to_liqmap: "← 返回流动性地图",
    open_cycles: "📈 周期",
    open_cycles_title: "前往历史周期地图",
    loading: "正在加载历史数据…",
    simulating: "模拟中…",
    err_load: "无法加载数据。请重试。",
    err_simulate: "无法计算模拟结果。",
    retry: "重试",
    form_title: "模拟参数",
    form_coin: "资产",
    form_start: "起始日期",
    form_start_help: "首个可用周收盘：{date}",
    form_amount: "每周金额（USD）",
    form_fee: "每次购买手续费（%）",
    form_fee_help: "估算值。实际交易所可能收取不同费率。",
    form_submit: "计算DCA",
    form_reset: "重置",
    bnb_disabled_label: "BNB",
    bnb_disabled_tooltip: "Kraken历史数据不足（<2年，自2025-04-17起）——即将推出。",
    summary_title: "模拟结果",
    summary_invested: "总投入",
    summary_invested_help: "总金额。包含已支付手续费。",
    summary_current_value: "当前价值",
    summary_current_value_help: "累计币数 × 当前价格。",
    summary_pnl: "盈利/亏损",
    summary_pnl_pct: "{pct}%",
    summary_coin_total: "累计{coin}",
    summary_avg_cost: "每{coin}平均成本",
    summary_fees_total: "已支付手续费",
    summary_weeks: "{n}周",
    summary_first_buy: "首次购买：{date}",
    summary_last_buy: "最后购买：{date}",
    summary_current_price: "当前价格：{price}",
    chart_title: "逐周演变",
    chart_subtitle: "投资组合价值 vs 总投入（累计）。周收盘数据。",
    chart_axis_y_usd: "USD",
    chart_legend_value: "投资组合价值",
    chart_legend_invested: "总投入",
    table_title: "逐周明细",
    table_collapsed: "查看明细（{n}周）",
    table_expanded: "隐藏明细",
    table_col_date: "日期",
    table_col_price: "价格",
    table_col_invested: "投入",
    table_col_fee: "手续费",
    table_col_coin_bought: "购买量",
    table_col_coin_acc: "累计",
    table_col_value: "价值",
    caveats_panel_title: "此模拟未告诉您的内容",
    caveats_panel_intro: "解读结果前需了解的五个限制：",
    caveats_retrospective: "这显示了在这些确切参数下会发生什么。这不是对从今天开始DCA会发生什么的预测。",
    caveats_cherry_picking: "结果会根据起始日期大幅变化。提前/推迟3个月开始可能导致盈亏变化>50%。请尝试多个日期。",
    caveats_no_slippage: "假设在周收盘时完美执行。实际中存在点差、滑点，有时在极端事件期间（2020年3月、FTX等）交易所无法交易。",
    caveats_fees_estimated: "手续费百分比是统一的——实际交易所根据交易量、交易对和订单类型（maker/taker、VIP、质押折扣）收取不同费用。",
    caveats_no_taxes: "不包含资本利得税或所得税。您所在司法管辖区可能对出售盈利征收19-35%+的税款。",
    source_label: "数据来源：Kraken周OHLC数据",
    no_data_yet: "请填写表单以查看结果。",
    entry_button_label: "💰 DCA",
    entry_button_title: "打开历史DCA模拟器——查看如果您每周投资会发生什么",
  },
  de: {
    title: "Historischer DCA-Simulator",
    subtitle: "Was wäre passiert, wenn du jede Woche $X in Krypto investiert hättest?",
    back_to_liqmap: "← Zurück zur Liquidity Map",
    open_cycles: "📈 Zyklen",
    open_cycles_title: "Zur historischen Zyklen-Karte",
    loading: "Lade historische Daten…",
    simulating: "Simuliere…",
    err_load: "Daten konnten nicht geladen werden. Bitte erneut versuchen.",
    err_simulate: "Simulation konnte nicht berechnet werden.",
    retry: "Erneut versuchen",
    form_title: "Simulationsparameter",
    form_coin: "Asset",
    form_start: "Startdatum",
    form_start_help: "Erster verfügbarer Wochenschluss: {date}",
    form_amount: "Wöchentlicher Betrag (USD)",
    form_fee: "Gebühr pro Kauf (%)",
    form_fee_help: "Geschätzt. Deine Exchange kann andere Gebühren erheben.",
    form_submit: "DCA berechnen",
    form_reset: "Zurücksetzen",
    bnb_disabled_label: "BNB",
    bnb_disabled_tooltip: "Unzureichende Verlaufsdaten auf Kraken (<2 Jahre, seit 2025-04-17) — demnächst verfügbar.",
    summary_title: "Simulationsergebnis",
    summary_invested: "Gesamt investiert",
    summary_invested_help: "Bruttobetrag. Inkl. gezahlter Gebühren.",
    summary_current_value: "Aktueller Wert",
    summary_current_value_help: "Akkumulierte Coin × aktueller Preis.",
    summary_pnl: "Gewinn / Verlust",
    summary_pnl_pct: "{pct}%",
    summary_coin_total: "{coin} akkumuliert",
    summary_avg_cost: "Durchschnittskosten pro {coin}",
    summary_fees_total: "Gezahlte Gebühren",
    summary_weeks: "{n} Wochen",
    summary_first_buy: "Erster Kauf: {date}",
    summary_last_buy: "Letzter Kauf: {date}",
    summary_current_price: "Aktueller Preis: {price}",
    chart_title: "Wöchentliche Entwicklung",
    chart_subtitle: "Portfolio-Wert vs. gesamt investiert (kumuliert). Wochenschlüsse.",
    chart_axis_y_usd: "USD",
    chart_legend_value: "Portfolio-Wert",
    chart_legend_invested: "Gesamt investiert",
    table_title: "Wöchentliche Details",
    table_collapsed: "Details anzeigen ({n} Wochen)",
    table_expanded: "Details ausblenden",
    table_col_date: "Datum",
    table_col_price: "Preis",
    table_col_invested: "Investiert",
    table_col_fee: "Gebühr",
    table_col_coin_bought: "Gekauft",
    table_col_coin_acc: "Akkumuliert",
    table_col_value: "Wert",
    caveats_panel_title: "Was diese Simulation NICHT zeigt",
    caveats_panel_intro: "Fünf ehrliche Einschränkungen vor der Interpretation des Ergebnisses:",
    caveats_retrospective: "Dies zeigt, was mit diesen exakten Parametern passiert WÄRE. Es ist KEINE Vorhersage, was passiert, wenn du ab heute DCAst.",
    caveats_cherry_picking: "Das Ergebnis variiert drastisch je nach Startdatum. Ein Start 3 Monate früher/später kann den PnL um >50% ändern. Teste verschiedene Daten.",
    caveats_no_slippage: "Nimmt perfekte Ausführung zum Wochenschluss an. In der Realität gab es Spread, Slippage und manchmal fehlende Verfügbarkeit auf Exchanges während extremer Ereignisse (März 2020, FTX etc.).",
    caveats_fees_estimated: "Der Gebühren-Prozentsatz ist einheitlich — deine tatsächliche Exchange berechnet unterschiedlich je nach Volumen, Paar und Ordertyp (Maker/Taker, VIP, Staking-Rabatte).",
    caveats_no_taxes: "Enthält keine Steuern auf Kapitalgewinne. Deine Jurisdiktion kann 19-35%+ auf den Gewinn beim Verkauf erheben.",
    source_label: "Quelle: Kraken OHLC wöchentlich",
    no_data_yet: "Fülle das Formular aus, um das Ergebnis zu sehen.",
    entry_button_label: "💰 DCA",
    entry_button_title: "Historischen DCA-Simulator öffnen — was wäre passiert, wenn du jede Woche investiert hättest",
  },
};

export const tDca = (lang) => DCA_T[lang] || DCA_T.es;

// Coin set must match backend `DCA_COINS` (BNB excluded — see _kraken.py).
export const DCA_COINS = ["BTC", "ETH", "SOL", "XRP", "ZEC"];
